export default __webpack_public_path__ + "static/media/fight_button.e898909f.png";